import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const schoolDataForm: Form<Child> = {
  key: 'schoolData',
  title: 'Schule während Frauenhaus',
  fields: [
    {
      key: 'typeOfSchool',
      label: 'Schulart',
      fieldTypes: 'select',
      options: [],
    },
    {
      key: 'schoolClass',
      label: 'Klasse',
      fieldTypes: 'text',
    },
    {
      key: 'schoolReligion',
      label: 'Religion',
      fieldTypes: 'select',
      options: [],
    },
    {
      key: 'schoolAdress',
      label: 'Adresse',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'schoolPhone',
      label: 'Telefon',
      fieldTypes: 'text',
    },
    {
      key: 'schoolTeacher',
      label: 'Lehrkraft',
      fieldTypes: 'text',
    },
    {
      key: 'schoolNotice',
      label: 'Notiz',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default schoolDataForm;
